import React from 'react';

import { Flex } from '@/shared/components/Flex';
import { Typography } from '@/shared/components/Typography';
import { CuratorLink } from '@/shared/components/WhiteLabelTitleHeaders/ui/CuratorLink';
import { ReactComponent as LidoWhiteIcon } from '@/shared/assets/icons/lido_logo_white.svg';
import { useTheme } from '@/services/theme';

type LidoStrategyTitleHeaderProps = {
  link: string;
};

export const LidoStrategyTitleHeader: React.FC<LidoStrategyTitleHeaderProps> = ({ link }) => {
  const { theme } = useTheme();

  return (
    <Flex direction="row" gap="10px" align="center">
      <Typography
        color="secondary"
        fontFamily="gramatika"
        size="14px"
        weight={700}
        variant="body1"
        lineHeight="15px"
        letterSpacing="0.05em"
      >
        CHECK ON
      </Typography>

      <CuratorLink to={link} target="_blank">
        <Flex
          align="center"
          justify="center"
          padding="10px"
          height="34px"
          borderRadius="8px"
          background={theme.colors.lido}
        >
          <LidoWhiteIcon style={{ width: '80px', height: '24px', color: '#fff', fill: '#fff' }} />
        </Flex>
      </CuratorLink>
    </Flex>
  );
};
